/* eslint-disable import/no-extraneous-dependencies */
import faker from 'faker';
import moment, { Moment } from 'moment';
import { DEFAULT_DATE_FORMAT } from 'api/models';
import { getRandomColor } from 'utils/get-random-color';
import { dateSorter } from 'utils/sorters';
import { floatUid } from 'utils/uid';

const getRandomNumber = (number) =>
  Math.abs(Math.round(Math.random() * number));

export const getRandomTeamMember = (number) => {
  return [...Array(number)].map((_, index) => ({
    id: `${floatUid()}_${index}`,
    name: faker.name.findName(),
    type: 'user',
  }));
};
const getRandomUser = (id, number, teamMembers) => {
  return [...Array(number)].map((_, index) => {
    const aMember =
      teamMembers[getRandomNumber(teamMembers.length) % teamMembers.length];

    return {
      id: `${id}_${floatUid()}_${index}_userId_${aMember.id}`,
      name: aMember.name,
      userId: aMember.id,
      type: 'user',
    };
  });
};
const getRandomRole = (id, number, teamMembers) => {
  return [...Array(number)].map((_, index) => {
    const randomId = `${id}_${floatUid()}_${index}`;
    // const t = getRandomNumber(3);

    return {
      id: randomId,
      name: faker.random.word(),
      type: 'role',
      children: getRandomUser(randomId, 3, teamMembers),
    };
  });
};

export const getRandomProjects = (noOfprojects: number, teamMembers: any[]) => {
  return [...Array(noOfprojects)].map((_, index) => {
    const randomId = `${floatUid()}_${index}`;

    return {
      id: randomId,
      name: faker.random.word(),
      description: faker.random.words(),
      type: 'project',
      resourceMargin: 21,
      children: getRandomRole(randomId, 1, teamMembers),
    };
  });
};
const getPhases = (resourceId, startDate: Moment, endDate: Moment) => {
  let maxDifference = startDate.diff(endDate, 'day');
  const events: any[] = [];
  const assigments: any[] = [];
  let tStartDate = startDate;

  while (maxDifference < 0) {
    const randomNumber = getRandomNumber(maxDifference);
    const tEndDate = tStartDate.add(randomNumber < 2 ? 2 : randomNumber, 'day');

    maxDifference = tEndDate.diff(endDate, 'day');
    const id = `project-phase_${floatUid()}_${resourceId}${getRandomNumber(
      100,
    )}`;

    events.push({
      id,
      resourceId,
      name: faker.random.word(),
      startDate: tStartDate.toDate(),
      endDate: tEndDate.toDate(),
      type: 'project-phase',
      resizable: false,
      draggable: false,
      eventColor: getRandomColor(floatUid()),
      cls: 'project-phase',
    });
    assigments.push({
      id:
        'phase-assigment-' +
        `${floatUid()}_${resourceId}${getRandomNumber(100)}`,
      eventId: id,
      resourceId,
    });
    tStartDate = tEndDate;
  }

  return {
    events,
    assigments,
  };
};

export const getOverallocation = (startDate: Moment, endDate: Moment) => {
  let maxDifference = startDate.diff(endDate, 'day');
  const events: any[] = [];
  let tStartDate = startDate;
  const limit = getRandomNumber(5);

  while (maxDifference < 0) {
    const randomNumber = getRandomNumber(maxDifference);
    const tEndDate = tStartDate.add(randomNumber ? 1 : randomNumber, 'day');

    maxDifference = tEndDate.diff(endDate, 'day');

    if (events.length === limit) {
      break;
    }

    events.push({
      startDate: tStartDate.startOf('day').toDate(),
      endDate: tEndDate.endOf('day').toDate(),
    });
    tStartDate = tEndDate.add(getRandomNumber(5), 'day');
  }

  return events;
};

const getRandomAllocation = (resourceId, startDate: Moment) => {
  const noofAllocation = getRandomNumber(10);
  let tStartDate = startDate;
  const events: any[] = [];
  const assigments: any[] = [];

  [...Array(noofAllocation)].forEach(() => {
    const t = getRandomNumber(10);
    const tEndDate = tStartDate.add(t < 2 ? 2 : t, 'day');
    const id = `allocation${floatUid()}_${resourceId}_${getRandomNumber(100)}`;

    events.push({
      id,
      type: 'allocation',
      minutesPerDay: (getRandomNumber(10) || 1) * 60,
      resourceId,
      startDate: tStartDate.startOf('day').toDate(),
      splitMode: false,
      endDate: tEndDate.endOf('day').toDate(),
      overAllocations: [],
      eventColor: '#D0E2FF',
      cls: 'allocation',
      name: faker.internet.userName(),
      manuallyScheduled: true,
    });
    assigments.push({
      id: `allocation-assigments-${floatUid()}_${resourceId}_${getRandomNumber(
        100,
      )}`,
      eventId: id,
      resourceId,
    });
    const b = getRandomNumber(3);

    tStartDate = tEndDate.add(b < 2 ? 2 : b, 'day');
  });

  return { events, assigments };
};

const getTaskIntensity = (resourceId, startDate: Moment) => {
  const noofAllocation = getRandomNumber(20);
  let tStartDate = startDate;
  let endDate = startDate;

  const events: any[] = [];
  const assigments: any[] = [];
  const eventId = `task_intensity_${floatUid()}_${resourceId}_${getRandomNumber(
    100,
  )}`;
  const intensities: any[] = [];

  [...Array(noofAllocation || 1)].forEach(() => {
    const t = getRandomNumber(10);
    const tEndDate = tStartDate.add(t < 2 ? 2 : t, 'day');
    const a = getRandomNumber(10) || 1;

    intensities.push({
      numberOfTasks: a,
      startDate: tStartDate.startOf('day').toDate(),
      endDate: tEndDate.endOf('day').toDate(),
    });
    tStartDate = tEndDate.add(getRandomNumber(3), 'day');
    endDate = tEndDate;
  });

  events.push({
    id: eventId,
    resourceId,
    startDate: startDate.startOf('day').toDate(),
    endDate: endDate.endOf('day').toDate(),
    type: 'task-intensity',
    intensities,
    cls: 'task-intensity',
  });
  assigments.push({
    id: `assigment-${floatUid()}${getRandomNumber(10)}`,
    eventId,
    resourceId,
  });

  return {
    events,
    assigments,
  };
};

const isEventBetweenDate = (event, startDate: Date, endDate: Date) => {
  const { startDate: tStartDate, endDate: tEndDate } = event;

  return (
    moment(tStartDate).isBetween(
      moment(startDate),
      moment(endDate),
      'day',
      '[]',
    ) ||
    moment(tEndDate).isBetween(
      moment(startDate),
      moment(endDate),
      'day',
      '[]',
    ) ||
    moment(startDate).isBetween(
      moment(tStartDate),
      moment(tEndDate),
      'day',
      '[]',
    ) ||
    moment(endDate).isBetween(moment(tStartDate), moment(tEndDate), 'day', '[]')
  );
};

const getEventsBetweenDates = (
  events: any[],
  startDate: Date,
  endDate: Date,
  currentEventId?: string,
) => {
  return events.filter((event) => {
    const { id } = event;

    if (id === currentEventId) {
      return false;
    }

    return isEventBetweenDate(event, startDate, endDate);
  });
};
const getMinEndDateToBeChecked = (
  events: any[],
  originalEventEndDate: Date,
) => {
  const maximumEndDate: Moment | null = events
    .map(({ endDate }) => moment(endDate))
    .reduce(
      (finalDate: Moment | null, date) =>
        finalDate == null
          ? finalDate
          : date.isAfter(finalDate)
          ? date
          : finalDate,
      null,
    );

  return maximumEndDate == null
    ? originalEventEndDate
    : moment(originalEventEndDate).isBefore(maximumEndDate)
    ? originalEventEndDate
    : maximumEndDate;
};
const getAllocationForDay = (events, day: Moment) => {
  const filteredEvents = events.filter(
    ({ startDate: collidingStartDate, endDate: collidingEndDate }) => {
      return moment(day).isBetween(
        moment(collidingStartDate),
        moment(collidingEndDate),
        'day',
        '[]',
      );
    },
  );

  return filteredEvents
    .map(({ minutesPerDay }) => minutesPerDay)
    .reduce((total, minutesPerDay) => total + minutesPerDay, 0);
};

export const getAllocationEventsForUser = (
  events: any[],
  userId,
  startDate?: Date,
  endDate?: Date,
) => {
  return events.filter((event) => {
    const { resourceId, type } = event;

    if (type !== 'allocation') {
      return false;
    }
    const [, allocationUserId] = resourceId.split('_userId_');

    if (allocationUserId !== userId) {
      return false;
    }

    if (!startDate || !endDate) {
      return true;
    }

    return isEventBetweenDate(event, startDate, endDate);
  });
};

export const populateOverAllocation = (
  events,
  maxWorkingMinutes,
  allocationStartDate?: Date,
  allocationEndDate?: Date,
) => {
  events.forEach((event) => {
    const { startDate, endDate, id: eventId } = event;

    if (allocationStartDate && allocationEndDate) {
      const newAllocations = event.overAllocations
        .map((allocation) => {
          const startDateIsBetween = moment(allocation.startDate).isBetween(
            moment(allocationStartDate),
            moment(allocationEndDate),
            'day',
            '[]',
          );
          const endDateIsBetween = moment(allocation.endDate).isBetween(
            moment(allocationStartDate),
            moment(allocationEndDate),
            'day',
            '[]',
          );

          if (startDateIsBetween && endDateIsBetween) {
            return null;
          }
          if (startDateIsBetween) {
            return {
              ...allocation,
              startDate: moment(endDate).add(1, 'day').toDate(),
            };
          }
          if (endDateIsBetween) {
            return {
              ...allocation,
              endDate: moment(startDate).subtract(1, 'day').toDate(),
            };
          }

          return allocation;
        })
        .filter(Boolean);

      event.overAllocations.splice(0);
      event.overAllocations.push(...newAllocations);
    } else {
      event.overAllocations.splice(0);
    }
    const collidingEvents = getEventsBetweenDates(
      events,
      startDate,
      endDate,
      eventId,
    );

    const toCheckUntil = getMinEndDateToBeChecked(collidingEvents, endDate);
    let start = moment(startDate);
    let overAllocationStartDate;
    let previousOverAllocations;

    while (start.isSameOrBefore(moment(toCheckUntil))) {
      const allocations = getAllocationForDay(
        [...collidingEvents, event],
        start,
      );

      if (allocations > maxWorkingMinutes) {
        const overAllocations = allocations - maxWorkingMinutes;

        if (!previousOverAllocations) {
          previousOverAllocations = overAllocations;
          overAllocationStartDate = start;
        } else if (previousOverAllocations !== overAllocations) {
          event.overAllocations.push({
            startDate: overAllocationStartDate.toDate(),
            endDate: start.toDate(),
            overMinutes: previousOverAllocations,
          });
          previousOverAllocations = overAllocations;
          overAllocationStartDate = start;
        }
      } else if (previousOverAllocations) {
        event.overAllocations.push({
          startDate: overAllocationStartDate.toDate(),
          endDate: start.toDate(),
          overMinutes: previousOverAllocations,
        });
        previousOverAllocations = 0;
      }
      start = start.add(1, 'day');
    }
    if (previousOverAllocations) {
      event.overAllocations.push({
        startDate: overAllocationStartDate.toDate(),
        endDate: toCheckUntil,
        overMinutes: previousOverAllocations,
      });
    }
  });
};

export const getEventsForProject = (
  projects,
  teamMembers,
  maxWorkingMinutes,
) => {
  const events: any[] = [];
  const assignments: any[] = [];

  let date = moment().subtract(projects.length / 5, 'month');

  projects.forEach((project, index) => {
    const randomId = `${floatUid()}_${index}`;
    const startDate = date.add(getRandomNumber(7), 'day');
    const endDate = startDate.add(getRandomNumber(90), 'day');

    if (index % 4 === 0) {
      date = endDate;
    }

    events.push({
      splitMode: false,
      autoExposeFields: true,
      id: `project_timeline_${randomId}`,
      resourceId: project.id,
      type: 'project',
      resizable: false,
      draggable: false,
      active: false,
      startDate: startDate.startOf('day').toDate(),
      endDate: endDate.endOf('day').toDate(),
      eventColor: '#0F62FE',
      cls: 'project-timeline',
      wrapperCls: 'project-timeline',
      overAllocations: [],
      minutesPerDay: 0,
    });
    assignments.push({
      id: `timeline-assigment-${floatUid()}${getRandomNumber(100)}`,
      eventId: `project_timeline_${randomId}`,
      resourceId: project.id,
    });
    const { events: phaseEvents, assigments: phaseAssigments } = getPhases(
      project.id,
      startDate.startOf('day'),
      endDate.endOf('day'),
    );

    events.push(...phaseEvents);
    assignments.push(...phaseAssigments);
    project.children.forEach((role) => {
      role.children.forEach((teamMember) => {
        const { events: intensityEvents, assigments: intensityAssigments } =
          getTaskIntensity(teamMember.id, startDate);
        const { events: allocationEvents, assigments: allocationAssignments } =
          getRandomAllocation(teamMember.id, startDate);

        events.push(...allocationEvents);
        assignments.push(...allocationAssignments);
        events.push(...intensityEvents);
        assignments.push(...intensityAssigments);
      });
    });
  });
  const allocationsEvents = events.filter(({ type }) => type === 'allocation');

  teamMembers.forEach(({ id }) => {
    const currentMemberAllocations = getAllocationEventsForUser(
      allocationsEvents,
      id,
    );

    const sorted = currentMemberAllocations.sort(
      ({ startDate: a }, { startDate: b }) =>
        dateSorter(
          moment(a).format(DEFAULT_DATE_FORMAT),
          moment(b).format(DEFAULT_DATE_FORMAT),
        ),
    );

    populateOverAllocation(sorted, maxWorkingMinutes);
  });

  return { events, assignments };
};
